type TCallback = (...args: unknown[]) => unknown;
type TRunCallback = <T>(callback: () => T) => T;

const isCallback = (value: unknown): value is TCallback => typeof value === 'function';

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && Object.getPrototypeOf(value) === Object.prototype;

export const wrapCallbacksInZone = (value: unknown, run: TRunCallback): unknown => {
  if (isCallback(value)) {
    return (...args: unknown[]): unknown => run(() => value(...args));
  }

  if (Array.isArray(value)) {
    return value.map((item) => wrapCallbacksInZone(item, run));
  }

  if (isPlainObject(value)) {
    return Object.fromEntries(
      Object.entries(value).map(([key, entry]) => [key, wrapCallbacksInZone(entry, run)]),
    );
  }

  return value;
};
